(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["football-hoodie-landing"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.fh-section').forEach(function(root){
    var mainImg = root.querySelector('.fh-main-img');
    var toast = root.querySelector('.fh-toast');
    var qtyInput = root.querySelector('.fh-qty-input');

    function showToast(msg){
      toast.textContent = msg;
      toast.classList.add('show');
      setTimeout(function(){ toast.classList.remove('show'); }, 1800);
    }

    root.querySelectorAll('.fh-qty-minus').forEach(function(btn){
      btn.addEventListener('click', function(){
        qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1);
      });
    });
    root.querySelectorAll('.fh-qty-plus').forEach(function(btn){
      btn.addEventListener('click', function(){
        qtyInput.value = parseInt(qtyInput.value || '1', 10) + 1;
      });
    });

    // Accordion
    root.querySelectorAll('.fh-accordion-item').forEach(function(item){
      var trigger = item.querySelector('.fh-accordion-trigger');
      trigger.addEventListener('click', function(){
        var wasOpen = item.classList.contains('open');
        root.querySelectorAll('.fh-accordion-item').forEach(function(i){ i.classList.remove('open'); });
        if (!wasOpen) item.classList.add('open');
      });
    });

    var variantsDataEl = root.querySelector('.fh-variants-data');

    if (variantsDataEl) {
      // Real-product mode: pill selectors resolve to a live variant.
      var variants = JSON.parse(variantsDataEl.textContent);
      var pillGroups = root.querySelectorAll('.fh-pills');
      var variantIdInput = root.querySelector('.fh-variant-id');
      var addBtn = root.querySelector('.fh-add-to-cart');
      var priceEl = root.querySelector('.fh-sale');

      function selectedOptions(){
        var opts = [];
        pillGroups.forEach(function(group){
          var active = group.querySelector('.fh-pill.active');
          opts.push(active ? active.dataset.value : null);
        });
        return opts;
      }

      function findVariant(opts){
        return variants.find(function(v){
          var vOpts = [v.option1, v.option2, v.option3].slice(0, opts.length);
          return vOpts.every(function(val, i){ return val === opts[i]; });
        });
      }

      function updateForVariant(variant){
        if (!variant) return;
        variantIdInput.value = variant.id;
        if (priceEl && variant.price) priceEl.textContent = (variant.price / 1).toLocaleString(undefined, { style: 'currency', currency: window.Shopify ? window.Shopify.currency.active : 'USD' });
        if (variant.featured_image && variant.featured_image.src) mainImg.src = variant.featured_image.src;
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }

      pillGroups.forEach(function(group){
        group.querySelectorAll('.fh-pill').forEach(function(pill){
          pill.addEventListener('click', function(){
            group.querySelectorAll('.fh-pill').forEach(function(p){ p.classList.remove('active'); });
            pill.classList.add('active');
            var labelEl = group.closest('.fh-option-block').querySelector('.fh-option-value');
            if (labelEl) labelEl.textContent = pill.dataset.value;
            updateForVariant(findVariant(selectedOptions()));
          });
        });
      });
    } else {
      // Demo mode: manual color/size selection, no real cart.
      var colorImages = {};
      root.querySelectorAll('.fh-thumb[data-color]').forEach(function(thumb){
        if (thumb.dataset.img) colorImages[thumb.dataset.color] = thumb.dataset.img;
      });
      var swatches = root.querySelectorAll('.fh-swatch');
      var thumbs = root.querySelectorAll('.fh-thumb');
      var colorValueEl = root.querySelector('.fh-color-value');
      var sizeBtns = root.querySelectorAll('.fh-size-btn');
      var sizeValueEl = root.querySelector('.fh-size-value');
      var demoAddBtn = root.querySelector('.fh-demo-add');

      function selectColor(color){
        if (colorValueEl) colorValueEl.textContent = color;
        if (colorImages[color]) mainImg.src = colorImages[color];
        thumbs.forEach(function(t){ t.classList.toggle('active', t.dataset.color === color); });
        swatches.forEach(function(s){ s.classList.toggle('active', s.dataset.color === color); });
      }

      thumbs.forEach(function(t){ t.addEventListener('click', function(){ selectColor(t.dataset.color); }); });
      swatches.forEach(function(s){ s.addEventListener('click', function(){ selectColor(s.dataset.color); }); });

      sizeBtns.forEach(function(btn){
        btn.addEventListener('click', function(){
          sizeBtns.forEach(function(b){ b.classList.remove('active'); });
          btn.classList.add('active');
          if (sizeValueEl) sizeValueEl.textContent = btn.dataset.size;
        });
      });

      if (demoAddBtn) {
        demoAddBtn.addEventListener('click', function(){
          if (!sizeValueEl || sizeValueEl.textContent === 'Select a size') {
            showToast('Please select a size');
            return;
          }
          showToast('Added to cart — ' + (colorValueEl ? colorValueEl.textContent : '') + ' / ' + sizeValueEl.textContent);
        });
      }
    }

    // Real-product add-to-cart feedback (form still submits normally to /cart/add).
    var productForm = root.querySelector('.fh-product-form');
    if (productForm) {
      productForm.addEventListener('submit', function(){
        showToast('Adding to cart…');
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
